import React, { createContext, useContext } from 'react'
import { configManager } from '../../../Managers/Config'
import { EventManager } from '../../../Managers/Event/EventManager'
import { MergeConfigAndPropsTask } from '../../../Tasks/Utils/MergeConfigAndPropsTask'
import { FormStore } from '../Stores/FormStore'

/**
 * Создает новый экземпляр FormStore с заданной конфигурацией
 */
export const createFormContext = (props: any = {}): FormStore => {
    // Отримуємо конфігурацію Form
    const formConfig = configManager.get('FormConfig', {})
    
    // Об'єднуємо конфігурацію з пропсами через MergeConfigAndPropsTask
    const mergedProps = MergeConfigAndPropsTask({
        formConfig,
        formProps: props,
    }) || props

    mergedProps.eventHandlers ??= {}
    
    if (typeof mergedProps.eventHandlers?.onSubmit !== 'function' && typeof mergedProps.onSubmit === 'function') {
        mergedProps.eventHandlers.onSubmit = { defaultOnSubmit: mergedProps.onSubmit }
        delete mergedProps.onSubmit
    }
    
    if (typeof mergedProps.eventHandlers?.onChange !== 'function' && typeof mergedProps.onChange === 'function') {
        mergedProps.eventHandlers.onChange = { defaultOnChange: mergedProps.onChange }
        delete mergedProps.onChange
    }
    
    // Створюємо тимчасовий eventManager для виконання onBeforeInit
    const tempEventManager = new EventManager()
    
    // Виконуємо всі onBeforeInit події з переданих пропсів
    if (mergedProps.eventHandlers?.onBeforeInit) {
        Object.entries(mergedProps.eventHandlers.onBeforeInit).forEach(([name, handler]) => {
            tempEventManager.on('onBeforeInit', name, handler as any)
        })
    }
    
    tempEventManager.emit('onBeforeInit', { props: mergedProps })
    
    const formContext = new FormStore(mergedProps)
    
    // Виконуємо onAfterInit події з eventManager створеного екземпляра
    formContext.getEventManager().emit('onAfterInit', { formContext })
    
    return formContext
}

/**
 * React Context для FormStore
 */
export const FormContext = createContext<FormStore | null>(null)

/**
 * Hook для получения контекста формы
 */
export const useFormContext = (): FormStore | null => {
    const context = useContext(FormContext)
    return context
}

interface FormContextProviderProps {
    children: React.ReactNode
    value: FormStore
}

export const FormContextProvider: React.FC<FormContextProviderProps> = ({ children, value }) => {
    return <FormContext.Provider value={value}>{children}</FormContext.Provider>
}
